import { useState } from "react";
import type { Movie } from "@/mocks/movies";

const modeIconMap: Record<string, string> = {
  在线观看: "ri-play-circle-line",
  免费观看: "ri-vip-diamond-line",
  高清播放: "ri-hd-line",
  手机在线: "ri-smartphone-line",
};

export default function MovieCard({ movie }: { movie: Movie }) {
  const [open, setOpen] = useState(false);

  return (
    <article className="group h-full flex flex-col bg-background-50 rounded-lg border border-background-200 overflow-hidden transition-colors hover:border-primary-300">
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 在线观看与播放信息`}
          className="w-full h-full object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-foreground-950/85 to-transparent"></div>
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
          {movie.type}
        </span>
        <span className="absolute top-3 right-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-medium">
          <i className="ri-star-fill text-accent-500 text-xs" aria-hidden="true"></i>
          {movie.recommend}
        </span>
        <div className="absolute bottom-3 left-3 right-3">
          <h3 className="font-heading text-base md:text-lg font-semibold text-background-50 truncate">{movie.title}</h3>
          <p className="text-xs text-background-100/80 mt-0.5">
            {movie.region} · {movie.year}
          </p>
        </div>
      </div>

      <div className="flex-1 flex flex-col p-4">
        <div className="flex flex-wrap gap-1.5">
          {movie.genres.map((g) => (
            <span key={g} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs">
              {g}
            </span>
          ))}
          {movie.episodes && (
            <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-900 text-xs">
              全 {movie.episodes} 集
            </span>
          )}
        </div>

        <p className={`mt-3 text-xs md:text-sm text-foreground-600 leading-relaxed ${open ? "" : "line-clamp-2"}`}>
          {movie.synopsis}
        </p>

        {open && (
          <div className="mt-3 pt-3 border-t border-background-200">
            <p className="text-xs text-foreground-500 mb-2">片长 / 集数：{movie.duration}</p>
            <div className="flex flex-wrap gap-1.5 mb-3">
              {movie.tags.map((t) => (
                <span key={t} className="text-xs text-foreground-500">
                  #{t}
                </span>
              ))}
            </div>
            <p className="text-xs text-foreground-500 mb-2">可用播放方式</p>
            <div className="flex flex-wrap gap-3">
              {movie.mode.map((m) => (
                <span key={m} className="inline-flex items-center gap-1 text-xs text-foreground-700">
                  <i className={`${modeIconMap[m]} text-sm text-primary-600`} aria-hidden="true"></i>
                  {m}
                </span>
              ))}
            </div>
          </div>
        )}

        <button
          onClick={() => setOpen((v) => !v)}
          className="mt-4 inline-flex items-center justify-center gap-1.5 w-full px-3 py-2 rounded-md border border-background-300 text-sm text-foreground-700 hover:bg-background-100 hover:border-primary-300 transition-colors cursor-pointer"
        >
          {open ? "收起详情" : "查看详情"}
          <i className={open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} aria-hidden="true"></i>
        </button>
      </div>
    </article>
  );
}